import HacizController from "../../../haciz/HacizController";
import {HacizEvrakTypeEnum} from "../../../uyap/enum/HacizEvrakTypeEnum";
import {AbstractTaskHandler} from "./AbstractTaskHandler";
import {ITask} from "../GorevYoneticisiTypes";
import {TopluTalepGonderTaskCevap} from "./TopluHacizHazirlaTaskHandler";
import {TaskDurum} from "../../../enum/TaskDurum";
import {StatusEnum} from "../../../enum/StatusEnum";
import JSZip from "jszip";
import app from "@/main";
import {DosyaBorclu} from "../../../uyap/DosyaBorclu";
import {DosyaBorcluEgmCevap} from "../../../uyap/DosyaBorcluEgm";
import {BorcluTakbisSorgulamaCevap} from "../../../uyap/BorcluTakbisSorgulama";
import {BorcluIcraDosyasiCevap, IIcraDosyasiSonuc} from "../../../uyap/BorcluIcraDosyasi";
import {BorcluPostaCekiCevap} from "../../../uyap/BorcluPostaCeki";
import {IKisiTumDVO} from "../../../uyap/CommonInterfaces";
import {BorcluSgkHacizCevap} from "../../../uyap/BorcluSgkHaciz";
import {getGonderilenTaleplerStr} from "../../../utils/talepBilgileriUtils";

const KESINLESME_MSG = "Borçlu hakkındaki icra takibi kesinleştirilmediği için sorgulama yapamazsınız. ";

/** UYAP: "Bu işlem 60 dakikada 1 defa yapılabilmektedir." */
const UYAP_60_DAKIKA_KODU = "PRTL_GNL_1-1";

function uyapHataMesaji(e: unknown): string {
    if (e != null && typeof e === "object") {
        const o = e as { message?: string; error?: string };
        if (typeof o.message === "string" && o.message.length > 0) return o.message;
        if (typeof o.error === "string") return o.error;
    }
    return String(e);
}

function uyapHataKodu(e: unknown): string | undefined {
    if (e != null && typeof e === "object") {
        const k = (e as { errorCode?: string }).errorCode;
        if (typeof k === "string" && k.length > 0) return k;
    }
    return undefined;
}

/** birimAdi + dosyaNo, dosyaId'nin aksine kalici olan tek kimlik ikilisi. */
function icraDosyaAnahtari(satir: { birimAdi?: string, dosyaNo?: string }): string {
    return (satir.birimAdi || "").trim() + "|" + (satir.dosyaNo || "").trim();
}

/**
 * Tazeleme sorgusu UYAP kotasindan dustugu icin, talep icerigiyle ilgisi olmayan hatalarda
 * (ag/timeout/oturum/imzaci) sorgu atilmaz.
 */
const TAZELENMEYECEK_HATALAR: readonly string[] = [
    "timeout",
    "network error",
    "oturum düştü",
    "sorgu kotası kalmadı",
    "imzacı",
];

function tazelemeDenenmeli(mesaj: string): boolean {
    const kucuk = mesaj.toLowerCase();
    return !TAZELENMEYECEK_HATALAR.some(parca => kucuk.includes(parca));
}

/**
 * UYAP gecidi coktugunde de tazeleme ise yaramaz: DEV-1131 har kaydinda istek icerigi hic
 * degismeden 26 dakika boyunca ayni portal sayfasi dondu, 18 talepli istek basarili olurken
 * tek talepli istek de ayni hatayi aldi. Ne var ki bayat dosyaId ile servis kesintisi ayni
 * mesaji uretebiliyor; bu yuzden ilk denemelerde yine tazeliyoruz, kesinti art arda
 * dogrulandiktan sonra her gorev icin bosuna kota harcamayi birakiyoruz.
 *
 * Sayac modul seviyesinde: her gorev icin yeni handler ornegi olusuyor, durum orada tutulamaz.
 */
const SERVIS_HATASI_IZI = "portal giriş sayfası";
const SERVIS_HATASI_TAZELEME_SINIRI = 2;
let ardArdaServisHatasi = 0;

function getBorcluKesinlesmeMesaji(borclu: DosyaBorclu): string | null {
    const sorguAlanlari = [
        (borclu.egm as any)?.message,
        (borclu.takbis as any)?.message,
        (borclu.sgkhaciz as any)?.message,
        (borclu.bankaBilgileri as any)?.message,
        (borclu.postaCeki as any)?.message,
        (borclu.sgkMossip as any)?.message,
        (borclu.icraDosyaKaydi as any)?.message
    ];
    const kesinlesmeVar = sorguAlanlari.some(msg =>
        msg && msg.includes("kesinleştirilmediği için sorgulama yapamazsınız")
    );
    return kesinlesmeVar ? KESINLESME_MSG : null;
}

export interface ResponseHacizEvrakInterface {
    message: string,
    status: StatusEnum,
    imzaliBlob: Blob | null,
    imzasizBlob: Blob | null,
    adSoyad: string,
    tcKimlikNo: string,
    evrakTutari: any,
    params: string,
    gonderilenTalepler: string
}

export interface TopluHacizGonderTaskResponse {
    dosyaEsasNo: string,
    icraDairesi: string,
    message: string,
    evraklar: ResponseHacizEvrakInterface[]
}

export class TopluHacizGonderTaskHandler extends AbstractTaskHandler {
    params: any[] = [];//!:HacizParamsInterface
    async handle(task: ITask): Promise<ITask> {
        let data: TopluTalepGonderTaskCevap = new TopluTalepGonderTaskCevap(task.data.dosya, task.data.params, task.data.borclu);
        data.dosya = await app.$uyap.DosyaBul().run(task);
        this.params = data.params.hacizParams;
        let response: TopluHacizGonderTaskResponse = {
            dosyaEsasNo: data.dosya.dosyaNo,
            icraDairesi: data.dosya.birimAdi,
            message: "",
            evraklar: []
        };
        try {
            const kesinlesmeMsg = getBorcluKesinlesmeMesaji(data.borclu);
            if (kesinlesmeMsg) {
                throw new Error(kesinlesmeMsg);
            }
            let hacizController = this.hacizControllerOlustur(data);
            if (hacizController.talepBilgileri.length == 0)
                throw new Error("Yapılan sorgulamalar sonucunda haciz talebi oluşturma şartları sağlanmamıştır");
            try {
                await hacizController.hacizEvrakHazirla();
                ardArdaServisHatasi = 0;
            } catch (e) {
                const hataMesaji = uyapHataMesaji(e);
                const servisHatasi = hataMesaji.includes(SERVIS_HATASI_IZI);
                ardArdaServisHatasi = servisHatasi ? ardArdaServisHatasi + 1 : 0;

                if (!this.alacakliOlduguDosyaTalebiVarMi(hacizController) || !tazelemeDenenmeli(hataMesaji))
                    throw e;
                if (servisHatasi && ardArdaServisHatasi > SERVIS_HATASI_TAZELEME_SINIRI)
                    throw e;
                // UYAP dosyaId'leri her cevapta yeniden sifreleniyor. Alacakli oldugu dosya talebi,
                // HacizController'daki tek "yabanci dosyaId" tasiyan talep turu; bu deger Hazirla
                // asamasinda alinip task ile birlikte kaydedildigi icin gonderim aninda bayat
                // olabiliyor. Gorevi bastan calistirmak bu degeri tazelemedigi (kullanicinin
                // sihirbazi bastan yapip borclulari elle secmesi gerektigi) icin tazeleme burada,
                // gonderim aninda yapiliyor. Sorgu kotadan dustugunden SADECE hata halinde ve
                // yalnizca dosyanin ucretsiz sorgu hakki varsa. (DEV-1131)
                await this.alacakliOlduguDosyalariTazele(data, hataMesaji);
                hacizController = this.hacizControllerOlustur(data);
                if (hacizController.talepBilgileri.length == 0)
                    throw e;
                await hacizController.hacizEvrakHazirla();
                ardArdaServisHatasi = 0;
            }
            //hacizController.hacizEvrakIndir();
            await hacizController.hacizEvrakImzala();
            let evrakResult = await hacizController.gonder();
            // gonder() UYAP hatasinda reject etmiyor, cevabi dondurup geciyor.
            // Kontrol edilmezse basarisiz gonderim "BITTI_BASARILI" olarak isaretleniyor.
            if (evrakResult.result === "error")
                throw new Error(evrakResult.message);
            let borcluKisi = data.borclu.borcluBilgileri as IKisiTumDVO;
            response.evraklar.push({
                message: evrakResult.message,
                status: StatusEnum.success,
                imzaliBlob: hacizController.getHacizEvrakImzali(),
                imzasizBlob: hacizController.getHacizEvrakImzasiz(),
                adSoyad: (borcluKisi.adi ? borcluKisi.adi : " ") + " " + (borcluKisi.soyadi ? borcluKisi.soyadi : " "),
                tcKimlikNo: (borcluKisi.tcKimlikNo ? borcluKisi.tcKimlikNo : ""),
                evrakTutari: hacizController.evrakTutar.toFixed(2),
                params: this.params.map(u => u.talepAdi).join(', '),
                gonderilenTalepler: getGonderilenTaleplerStr(hacizController.talepBilgileri)
            })
        } catch (e) {
            console.error("Toplu Haciz Gonder ERROR",e);
            let borcluKisi = data.borclu.borcluBilgileri as IKisiTumDVO;
            response.evraklar.push({
                message: (e as Error).message,
                status: StatusEnum.error,
                imzaliBlob: null,
                imzasizBlob: null,
                adSoyad: (borcluKisi.adi ? borcluKisi.adi : " ") + " " + (borcluKisi.soyadi ? borcluKisi.soyadi : " "),
                tcKimlikNo: (borcluKisi.tcKimlikNo ? borcluKisi.tcKimlikNo : ""),
                evrakTutari: 0,
                params: this.params.map(u => u.talepAdi).join(', '),
                gonderilenTalepler: 'Yok'
            });
        }

        let evrakVarMi = false;
        let zip = new JSZip();
        for (let evrak of response.evraklar) {
            if (evrak.imzaliBlob) {
                // @ts-ignore
                zip.file((evrak.adSoyad + "/" + evrak.imzaliBlob.name), evrak.imzaliBlob);
                evrakVarMi = true;
            }
        }

        if (evrakVarMi) {
            let zipBlob = await zip.generateAsync({type: "blob"});
            let formData = new FormData();
            // @ts-ignore
            let name = task.birim_adi + ' ' + task.dosya_esas_no.replaceAll('/', '_') + ' Toplu Haciz Talepleri.zip';
            formData.append('name', name);
            formData.append('file', zipBlob, name);
            formData.append('task_id', (task.id as string));
            await app.$http.post('/api/v1/task/file', formData);
        }

        let errorExists = response.evraklar.filter(evrak => evrak.status == StatusEnum.error);
        task.status = TaskDurum.BITTI_BASARILI;
        if (errorExists.length == response.evraklar.length)
            task.status = TaskDurum.BITTI_HATALI;
        else if (errorExists.length > 0)
            task.status = TaskDurum.BITTI_EKSIK;
        task.response = response;
        task.description = errorExists.map(x => x.message).join(" , ");
        if (response.message != "")
            task.description = response.message;
        return task;
    }

    /**
     * Secilen talep turlerinden talepBilgileri listesini kurar.
     * Ayri metod: alacakli oldugu dosya bilgileri tazelendikten sonra liste bastan kurulmali.
     */
    private hacizControllerOlustur(data: TopluTalepGonderTaskCevap): HacizController {
        let hacizController = new HacizController(data.borclu, data.dosya);
        for (const param of this.params) {
            switch (param.className) {
                case HacizEvrakTypeEnum.ARAC_HACZI: {
                    let egm = data.borclu.egm as DosyaBorcluEgmCevap;
                    console.log("HacizEvrakTypeEnum.ARAC_HACZI egm", egm);
                    if (egm.sorguSonucu && egm.sorguSonucDVO && egm.sorguSonucDVO.aracBilgileri.aracList) {
                        egm.sorguSonucDVO.aracBilgileri.aracList.forEach((arac) => {
                            if (arac.selected == true)
                                hacizController.aracHacizEkle(arac.hacizSerhi, arac.plakaSifreli, arac.plaka)
                        })
                    }
                    break;
                }
                case HacizEvrakTypeEnum.TASINMAZ_HACZI: {
                    let takbis = data.borclu.takbis as BorcluTakbisSorgulamaCevap;
                    if (takbis.sorguSonucu && Array.isArray(takbis.sorguSonucDVO)) {
                        takbis.sorguSonucDVO.forEach((tasinmaz) => {
                            if (tasinmaz.selected == true)
                                hacizController.tasinmazHacizEkle(tasinmaz);
                        })
                    }
                    break;
                }
                case HacizEvrakTypeEnum.ALACAKLI_OLDUGU_DOSYA: {
                    let icraDosyaKaydi = data.borclu.icraDosyaKaydi as BorcluIcraDosyasiCevap;
                    if (icraDosyaKaydi.sorguSonucu && icraDosyaKaydi.sorguSonucDVO) {
                        // Diger talep turlerinin aksine burada secim kontrolu yoktu; kullanicinin
                        // listeden kaldirdigi dosyalar da gonderiliyordu. UYAP evragi tek parca
                        // dogruladigi icin listedeki tek bir gecersiz satir (orn. Talimat Dosyasi)
                        // evragin tamamini dusuruyor. (DEV-1131)
                        icraDosyaKaydi.sorguSonucDVO
                            .filter((kayitliDosya) => kayitliDosya.selected !== false)
                            .forEach((kayitliDosya) => hacizController.alacakliOlduguDosyaEkle(kayitliDosya));
                    }
                    break;
                }
                case HacizEvrakTypeEnum.BANKA_HACZI: {
                    if (data.borclu.haciz.bankaHacziSelected !== false &&
                        data.borclu.haciz.bankaHesapHacziParams.bankaList.length > 0 &&
                        data.borclu.haciz.bankaHesapHacziParams.hesapList.length > 0) {
                        hacizController.bankaHacizEkle();
                    }
                    break;
                }
                case HacizEvrakTypeEnum.POSTA_CEKI_HACZI: {
                    let postaCeki = data.borclu.postaCeki as BorcluPostaCekiCevap;
                    if (data.borclu.haciz.postaCekiHacziSelected !== false && postaCeki.sorguSonucu)
                        hacizController.postaCekiHacziEkle();
                    break;
                }
                case HacizEvrakTypeEnum.SGK_MOSSIP_HACZI: {
                    let sgkMossip = data.borclu.sgkMossip as BorcluSgkHacizCevap;
                    if (sgkMossip.sorguSonucu && sgkMossip.sorguSonucDVO) {
                        sgkMossip.sorguSonucDVO.forEach((mossip) => {
                            if (mossip.selected == true)
                                hacizController.sgkMossipHacizEkle(mossip);
                        })
                    }
                    break;
                }
                case HacizEvrakTypeEnum.TASINIR_HACZI: {
                    if (data.borclu.haciz.tasinirHacziSelected !== false)
                        hacizController.tasinirHacizEkle(data.borclu.haciz.tasinirHacziParams.aciklama);
                    break;
                }
                case HacizEvrakTypeEnum.TASINIR_HACIZ_TALIMATI: {
                    if (data.borclu.haciz.tasinirHacizTalimatiSelected !== false)
                        hacizController.tasinirHacizTalimatiEkle(data.borclu.haciz.tasinirHacizTalimatiParams);
                    break;
                }
                case HacizEvrakTypeEnum.IHBARNAME_89_1: {
                    if (data.borclu.haciz.ihbarname89_1Selected !== false)
                        (data.borclu.haciz.ihbarname89_1Params || []).forEach(p => hacizController.ihbarname89_1Ekle(p));
                    break;
                }
                case HacizEvrakTypeEnum.IHBARNAME_89_2: {
                    if (data.borclu.haciz.ihbarname89_2Selected !== false)
                        (data.borclu.haciz.ihbarname89_2Params || []).forEach(p => hacizController.ihbarname89_2Ekle(p));
                    break;
                }
                case HacizEvrakTypeEnum.IHBARNAME_89_3: {
                    if (data.borclu.haciz.ihbarname89_3Selected !== false)
                        (data.borclu.haciz.ihbarname89_3Params || []).forEach(p => hacizController.ihbarname89_3Ekle(p));
                    break;
                }
                case HacizEvrakTypeEnum.MAAS_HACZI: {
                    let sgkhaciz = data.borclu.sgkhaciz as BorcluSgkHacizCevap
                    if (data.borclu.haciz.maasHacziSelected !== false && sgkhaciz.sorguSonucu) {
                        hacizController.maasHacizEkle(data.borclu.haciz.maasHacziParams)
                    }
                    break;
                }
            }
        }
        return hacizController;
    }

    private alacakliOlduguDosyaTalebiVarMi(hacizController: HacizController): boolean {
        return hacizController.talepBilgileri
            .some((talep: any) => talep.className == HacizEvrakTypeEnum.ALACAKLI_OLDUGU_DOSYA);
    }

    /**
     * Borclunun alacakli oldugu dosyalari UYAP'tan yeniden sorgulayip elimizdeki satirlarin
     * dosyaId'lerini gunceller. Eslestirme birimAdi + dosyaNo uzerinden yapilir; dosyaId
     * kalici olmadigi icin eslestirmede kullanilamaz.
     *
     * Yalnizca evrak hazirlama hata verdiginde cagrilir ve iki kapisi vardir: dosyanin
     * ucretsiz sorgu kotasi olmali (yoksa ucret kesilir) ve ayni sorgu UYAP'ta 60 dakikada
     * 1 kez yapilabilir. Ikisinden birine takilirsa kullaniciya ne yapmasi gerektigini
     * soyleyen bir mesajla cikilir.
     */
    private async alacakliOlduguDosyalariTazele(data: TopluTalepGonderTaskCevap, ilkHata: string): Promise<void> {
        const eskiSatirlar = (data.borclu.icraDosyaKaydi as BorcluIcraDosyasiCevap)?.sorguSonucDVO || [];
        if (eskiSatirlar.length == 0)
            throw new Error(ilkHata);

        // Tazeleme UYAP kotasindan dusuyor. Kota bitmisken sorgu atmak ucret kesilmesine yol
        // actigi icin, kotanin varligi DOGRULANMADAN UYAP'a gidilmiyor: bakiye okunamazsa da
        // tazeleme yapilmiyor (bakiye sorgusu da coktuyse tazeleme zaten basarisiz olurdu).
        let kalanSorgu: number;
        try {
            kalanSorgu = (await app.$uyap.SorguBakiyesi().run({dosyaId: data.dosya.dosyaId})).sorguKalanIslemSayisi;
        } catch (e) {
            throw new Error(ilkHata + " | Alacaklı olduğu dosya bilgileri yenilenecekti ancak " +
                "sorgu kotası okunamadığı için sorgu atılmadı: " + uyapHataMesaji(e));
        }
        if (kalanSorgu <= 0)
            throw new Error(ilkHata + " | Alacaklı olduğu dosya bilgilerinin yenilenmesi gerekiyor " +
                "fakat bu dosyanın ücretsiz sorgu kotası dolu. Kota yenilendikten sonra görevi tekrar çalıştırınız.");

        let taze: BorcluIcraDosyasiCevap;
        try {
            taze = await app.$uyap.BorcluIcraDosyasi().fresh().run({
                dosyaId: data.dosya.dosyaId,
                kisiKurumId: data.borclu.kisiKurumId
            });
        } catch (e) {
            const mesaj = uyapHataMesaji(e);
            if (uyapHataKodu(e) == UYAP_60_DAKIKA_KODU || mesaj.indexOf("60 dakikada 1 defa") >= 0)
                throw new Error(ilkHata + " | Alacaklı olduğu dosya bilgileri bayatlamış olabilir. " +
                    "Yenilemek için gereken UYAP sorgusu 60 dakikada 1 kez yapılabildiğinden yenileme yapılamadı; " +
                    "lütfen bir süre sonra tekrar deneyiniz.");
            throw new Error(ilkHata + " | Alacaklı olduğu dosya bilgileri yenilenemedi: " + mesaj);
        }

        if (!taze.sorguSonucu || !taze.sorguSonucDVO)
            throw new Error(ilkHata + " | Borçlunun alacaklı olduğu dosya kaydı UYAP'ta artık bulunamıyor.");

        const tazeSatirlar = new Map<string, IIcraDosyasiSonuc>();
        taze.sorguSonucDVO.forEach(satir => tazeSatirlar.set(icraDosyaAnahtari(satir), satir));

        let eslesenSayisi = 0;
        for (const satir of eskiSatirlar) {
            const yeni = tazeSatirlar.get(icraDosyaAnahtari(satir));
            if (!yeni) {
                // UYAP listesinde artik yok; gonderilirse evragin tamami duser.
                satir.selected = false;
                continue;
            }
            satir.dosyaId = yeni.dosyaId;
            satir.guncelKisiKurumId = yeni.guncelKisiKurumId;
            satir.dosyaTurKodu = yeni.dosyaTurKodu;
            satir.dosyaTurKoduAciklama = yeni.dosyaTurKoduAciklama;
            satir.dosyaDurumuAciklama = yeni.dosyaDurumuAciklama;
            eslesenSayisi++;
        }
        if (eslesenSayisi == 0)
            throw new Error(ilkHata + " | Alacaklı olduğu dosyaların hiçbiri güncel UYAP sorgusuyla eşleşmedi.");
        console.log("DEV-1131: alacaklı olduğu dosya bilgileri tazelendi, eşleşen satır:", eslesenSayisi);
    }
}